<template>
  <div class="preview-area">
    <div class="preview-step">
      <h3 class="">分享给微信好友</h3>
      <div class="preview-content preview-friends">
        <div class="preview-friends-box">
          <div class="title">{{previewObj.value.title}}</div>
          <div class="image"><img :src="previewObj.value.image"></div>
          <div class="platform"><img src="../assets/icon_link.png"><label>{{previewObj.value.platform}}</label></div>
        </div>

      </div>
    </div>
    <div class="preview-step">
      <h3 class="">分享给微信好友-聊天展示</h3>
      <div class="preview-content preview-chat">
        <div class="preview-chat-box">
          <div class="title">{{previewObj.value.title}}</div>
          <div class="left">
<!--            <div class="inviter">邀请人：{{preview.inviter}}</div><div class="grade">等级：{{preview.grade}}</div>-->
            <div class="content">{{previewObj.value.content}}</div>
          </div>
          <div class="image"><img :src="previewObj.value.image"></div>
          <div class="platform"><img src="../assets/icon_link.png"><label>{{previewObj.value.platform}}</label></div>

        </div>
      </div>
    </div>
    <div class="preview-step">
<!--      <h3 class="" @click="increment">分享至朋友圈{{ count }}</h3>-->
<!--      <h3 class="" @click="increment">分享至朋友圈{{ doubleCount() }}</h3>-->
      <h3 class="" @click="increment">分享至朋友圈</h3>
      <div class="preview-content preview-circle">
        <div class="preview-circle-box">
          <div class="image"><img :src="previewObj.value.image"></div>
          <div class="title">{{previewObj.value.title}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

import { storeToRefs } from 'pinia';
import { useCounterStoreForSetup } from '@/store/counterForOptions.ts';

// setup composition API模式
const counterStoreForSetup = useCounterStoreForSetup();
const { count } = storeToRefs(counterStoreForSetup);
const { increment, doubleCount } = counterStoreForSetup;


import { defineComponent, ref, reactive, toRefs, watch, onMounted } from '@vue/composition-api'
const props = defineProps({
  previewObj: {
    type: Object,
    required: true,
    default: () => {}
  }
})
const { previewObj } = toRefs(props)
/*
  watch: {
    $route () {
      // this.testFun();
    },
    list: {
      handler (newVal, oldVal) {
        // console.log('infoForm', newVal)
        const rQuery = this.$route.query
      },
      deep: true
    }
  },
*/

// created () {}
/*
const operation = (type:String, row:any) => {
  const obj = { type, row }
  this.$emit('onOperation', obj)
}
onMounted(() => {
  this.$nextTick(_ => {
    // console.log(this.preview)
  })
})
*/
</script>
<style lang="scss">
.preview-area{
  display: flex;
  .preview-step{
    //float: left;
    h3{
      text-align: center;
      margin-bottom: 16px;
      font-size: 16px;
      font-weight: bold;
      color: #333333;
    }
    .preview-content{
      width: 375px;
      height: 667px;
      overflow: hidden;
      border-radius: 20px;
      background-color: rgba(0,0,0,0.2);
      margin-bottom: 30px;
      border: 1px solid #ebebeb;
      position: relative;
    }
    .preview-friends{ background-image: url("../assets/preview-friends.png"); }
    .preview-chat{ background-image: url("../assets/preview-chat.png"); }
    .preview-circle{ background-image: url("../assets/preview-circle.png"); }
    .preview-friends-box, .preview-chat-box, .preview-circle-box{position: absolute;}
    .preview-friends-box .title, .preview-chat-box .title, .preview-circle-box .title{
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .preview-friends-box{
      width: 100px;
      height: 139px;
      background: #FFFFFF;
      border: 1px solid #E5E5E5;
      border-radius: 4px;
      padding: 5px 9px 5px 9px;
      top:265px;
      left: 128px;
      .title{
        font-weight: 400;
        color: #1C1C1C;
      }
      .image{
        width: 102px;
        height: 82px;
        background: #9E9E9E;
        img{
          width: 102px;
          height: 82px;
          //object-fit: fill;
          object-fit: cover;
        }
      }
      .platform{}
    }
    .preview-chat-box{
      width: 235px;
      height: 143px;
      background: #FFFFFF;
      border: 1px solid #E5E5E5;
      border-radius: 4px;
      padding: 8px 13px 0 13px;
      top: 133px;
      left: 55px;
      .title{
        font-size: 16px;
        font-weight: 400;
        color: #000000;
        margin-bottom: 11px;
      }
      .left{
        float: left;
        height: 47px;
        width: 75%;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        .inviter, .grade{
          font-size: 13px;
          font-weight: 400;
          color: #737373;
        }
        .content{

        }
      }
      .image{
        width: 47px;
        height: 47px;
        background: #979090;
        float: right;
        img{
          width: 47px;
          height: 47px;
          object-fit: cover;
        }
      }
      .platform{
        width: 100%;
        border-top: 1px solid #E0E0E0;
        font-weight: 400;
        color: #747474;
        float: left;
        margin-top: 10px;
      }
    }
    .preview-circle-box{
      width: 274px;
      //height: 44px;
      background-color: #F7F7F7;
      padding: 6px;
      top: 474px;
      left: 76px;
      .title{ float: right; width: calc(100% - 40px); }
      .image{
        width: 31px;
        height: 31px;
        background: #979090;
        float: left;
        img{
          width: 31px;
          height: 31px;
          object-fit: cover;
        }
      }
    }

  }
  .preview-step + .preview-step{
    margin-left: 48px;
  }
}
</style>
